import { DropdownItem } from '@atlaskit/dropdown-menu';
import { Text } from '@atlaskit/primitives-next';

import { FilterOption, MigrationPhase } from '../../../types';

export const MigrationPhaseFilterDropdownItem = ({
	option,
	isSelected,
	onPhaseChange,
	sendMigrationPhaseDropdownItemClickUIEvent,
}: {
	option: FilterOption<MigrationPhase>;
	isSelected: boolean;
	onPhaseChange: (option: FilterOption<MigrationPhase>) => void;
	sendMigrationPhaseDropdownItemClickUIEvent: (selectedMigrationPhase: MigrationPhase) => void;
}) => {
	return (
		<DropdownItem
			key={option.value}
			onClick={() => {
				sendMigrationPhaseDropdownItemClickUIEvent(option.value);
				onPhaseChange(option);
			}}
			isSelected={isSelected}
		>
			<Text>{option.label}</Text>
		</DropdownItem>
	);
};
